import {
  Calendar,
  Trash2,
} from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/style";

interface PlaceCardActionsProps {
  onRemove?: () => void
  onSchedule?: () => void
  className?: string
}

/**
 * Action buttons for place cards (Remove, Schedule)
 * Uses monochromatic button styling
 */
export function PlaceCardActions({
  onRemove,
  onSchedule,
  className,
}: PlaceCardActionsProps) {
  // Don't render if no actions provided
  if (!onRemove && !onSchedule) {
    return null
  }

  return (
    <div
      className={cn(
        'flex items-center justify-end gap-2 px-2 pb-2 bg-stone-100',
        className
      )}
    >
      {/* Remove button (ghost variant, left-aligned) */}
      {onRemove && (
        <Button
          variant="ghost"
          size="sm"
          onClick={(e) => {
            e.stopPropagation() // Prevent triggering card tap
            onRemove()
          }}
          className="text-magazine-ash hover:text-magazine-ink hover:bg-magazine-cream"
        >
          <Trash2 />
          Remove
        </Button>
      )}

      {/* Schedule button (default variant, right-aligned) */}
      {onSchedule && (
        <Button
          variant="outline"
          size="sm"
          onClick={(e) => {
            e.stopPropagation() // Prevent triggering card tap
            onSchedule()
          }}
          className="bg-magazine-paper hover:bg-magazine-cream"
        >
          <Calendar />
          Schedule
        </Button>
      )}
    </div>
  )
}
